var React = require('react');

function IconSetting2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M3 21.667v2.667h8v-2.667zm0-16v2.666h13.333V5.667zM16.333 27v-2.667H27v-2.666H16.333V19h-2.666v8zm-8-16v2.667H3v2.667h5.333V19H11v-8zM27 16.333v-2.666H13.667v2.667zM19 11h2.667V8.333H27V5.667h-5.333V3H19z","transform":"translate(-3 -3)"}));
}

IconSetting2.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconSetting2;

IconSetting2.default = IconSetting2;
